import { sortedTBYBFeaturesMap } from '../constants/featuresMap'; /**
                                                                  * Get a list of TBYB feature names from a list of paid features that
                                                                  * have been added to the survey.
                                                                  *
                                                                  * Args:
                                                                  *     addedPaidFeatures:
                                                                  *         List of paid features (wall_*) added to the survey
                                                                  *
                                                                  *     sortedTBYBFeaturesMap:
                                                                  *         List of objects mapping {paid_feature_name: tbyb_feature_name}
                                                                  *
                                                                  * Returns:
                                                                  *     List of TBYB feature names
                                                                  */

export default function matchPaidFeaturesToTBYBFeatures(addedPaidFeatures) {
  var matchedTBYBFeatures = {};
  sortedTBYBFeaturesMap.forEach(function (tbybFeature) {
    var key = Object.keys(tbybFeature)[0];
    if (addedPaidFeatures !== null && addedPaidFeatures !== void 0 && addedPaidFeatures.includes(key)) {
      matchedTBYBFeatures[tbybFeature[key]] = true;
    }
  });
  return Object.keys(matchedTBYBFeatures);
}